// Store individual recipients so existing unread/review logic targets only players.
export function addPlayerMentions(text, players, mentions = []) {
  const result = new Set(mentions);
  if (/(?:^|\s)@players\b/i.test(String(text || ''))) {
    result.add('@Players');
    (players || []).forEach(member => {
      if (member.username) result.add(`@${member.username}`);
    });
  }
  return [...result];
}
